module.exports = __webpack_public_path__ + "static/media/poster-solute.6cfb22da.jpg";